import { useEffect } from 'react';

import { getAnalyticConfigs } from '@utils/common';
import { useAppContext } from '@contexts/AppContext';

export function useIdleGtag() {
  const { isOutlet } = useAppContext();
  const { gtagId } = getAnalyticConfigs(isOutlet);

  useEffect(() => {
    const loadGtag = () => {
      const script = document.createElement("script");
      script.src = `https://www.googletagmanager.com/gtag/js?id=${gtagId}`;
      script.async = true;
      document.head.appendChild(script);
    };

    if ("requestIdleCallback" in window) {
      window.requestIdleCallback(loadGtag);
    } else {
      setTimeout(loadGtag, 1000);
    }
  }, [gtagId]);
}